export default "__VITE_ASSET__BOTm$GMi__"